class GiftWithPurchase extends window.BAO.CustomElement() {
  constructor () {
    super()

    this._loading = false

    this.sections = this.inPushCart
      ? window.BAO.sectionRenderer.pushCartSections
      : this.onCartPage
        ? window.BAO.sectionRenderer.cartSections
        : []
  }

  setupListeners () {
    super.setupListeners()

    if (this.cleanUp) {
      this.resetCart()
    }

    if (!this.variantId || !this.cartAmount) return

    this.handleGiftWithPurchase = this.handleGiftWithPurchase.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
      this.handleGiftWithPurchase,
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_REMOVE_ITEM,
      this.handleGiftWithPurchase,
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_ITEM_QUANTITY,
      this.handleGiftWithPurchase,
    )
  }

  /**
   * Adds the gift to the cart
   */
  async handleGiftWithPurchase (event) {
    let cartData = event.detail?.state

    if (!cartData || !cartData.items) {
      cartData = await this.getShopifyCart()
    }

    const freeGift = this.freeGift(cartData)

    if (cartData?.total_price < this.cartAmount && !!freeGift) {
      this.removeFreeGift(freeGift)
    } else if (cartData?.total_price >= this.cartAmount && !freeGift) {
      this.addFreeGift()
    }
  }

  async addFreeGift () {
    this.loading = true

    const itemToAdd = {
      id: this.variantId,
      quantity: 1,
      properties: {
        [this.propertyKey]: `true`,
        [`${this.propertyKey}_cart_amount`]: this.cartAmount,
      },
    }
    const state = await window.BAO.Cart.addItem(itemToAdd, {
      sections: this.sections.map(s => s.section),
    })

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)
  }

  async removeFreeGift (freeGift) {
    window.BAO.Cart.removeItem(freeGift.key)

    this.loading = true

    const state = await window.BAO.Cart.removeItem(freeGift.key, {
      sections: this.sections.map(s => s.section),
    })

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)
  }

  async resetCart () {
    const cartData = await this.getShopifyCart()
    const freeGift = this.freeGift(cartData)
    if (freeGift) {
      this.removeFreeGift(freeGift)
    }
  }

  /**
   * @param {boolean} Whether or not the cart already has the free gift
   */
  freeGift (cartData) {
    const giftItem = cartData.items.find(
      item => item.properties?.[this.propertyKey],
    )
    return giftItem
  }

  /**
   * @param {string} Returns the key to use for the lineitem property
   */
  get propertyKey () {
    return `__gift-with-purchase`
  }

  /**
   * @param {number} The variant id of the free gift item
   */
  get variantId () {
    return this.dataset?.variantId ? parseInt(this.dataset.variantId, 10) : null
  }

  /**
   * @param {Boolean} Cleanup Flag
   */
  get cleanUp () {
    return !!this.dataset?.cleanup
  }

  /**
   * @param {number} The amount the cart total needs to exceed before the gift is added to cart
   */
  get cartAmount () {
    return this.dataset?.cartAmount
      ? parseInt(this.dataset.cartAmount, 10) *
          Number(window.Shopify.currency.rate)
      : null
  }

  get loading () {
    return this._loading
  }

  set loading (val) {
    this._loading = val

    if (this.inPushCart) {
      this.pushCart.loading = val
    }

    this.setAttribute('aria-busy', val.toString())
  }

  async getShopifyCart () {
    try {
      const response = await fetch('/cart.js')
      const data = await response.json()
      return data
    } catch (error) {
      console.error(error)
      return null
    }
  }

  get pushCart () {
    return document.querySelector('push-cart')
  }

  get inPushCart () {
    return this.pushCart != null
  }

  get cart () {
    return document.querySelector('cart-items')
  }

  get onCartPage () {
    return this.cart != null
  }
}

if (!customElements.get('gift-with-purchase')) {
  customElements.define('gift-with-purchase', GiftWithPurchase)
}
